import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import { getURIParamValue } from 'src/modules/utils/analytics'
import { isValidQueryParam } from 'src/modules/utils/api'
import { body, heading, mediaQuery, spacing, typographyMixin } from 'src/constants/marketing-ds'

const HeroTitle = ({ title, subtitle, location }) => {
  const [stateTitle, setStateTitle] = useState(title)
  const [stateSubtitle, setStateSubtitle] = useState(subtitle)

  useEffect(() => {
    let titleVar = title
    let subtitleVar = subtitle

    const { search } = location
    const queryStringTitle = getURIParamValue(search, 'title')

    if (isValidQueryParam(queryStringTitle)) {
      titleVar = queryStringTitle
    }

    const queryStringSubInfo = getURIParamValue(location.search, 'subinfo')

    if (isValidQueryParam(queryStringSubInfo)) {
      subtitleVar = queryStringSubInfo
    }

    setStateTitle(titleVar)
    setStateSubtitle(subtitleVar)
  }, [title, subtitle, location])

  return (
    <HeadlineContain>
      <HeaderElement>{stateTitle}</HeaderElement>
      {stateSubtitle && <SubTitleElement>{stateSubtitle}</SubTitleElement>}
    </HeadlineContain>
  )
}

export default HeroTitle

const HeadlineContain = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin-bottom: ${spacing.lg};
  ${mediaQuery.tablet} {
    margin-bottom: ${spacing.xl};
  }
`

const HeaderElement = styled.h1`
  display: block;
  text-align: center;
  max-width: 700px;
  width: 90%;
  margin: 0 auto ${spacing.md};
  ${typographyMixin(heading.lg)}

  ${mediaQuery.tablet} {
    ${typographyMixin(heading.xl)}
  }
`

const SubTitleElement = styled.h2`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  ${typographyMixin(body.md)}
  ${mediaQuery.tablet} {
    ${typographyMixin(body.lg)}
  }
`
